const mergeData = (
  existing: Record<string, unknown>,
  incoming: Record<string, unknown>
): Record<string, unknown> => ({ ...existing, ...incoming });

export const cachePolicies = {
  Attribute: {
    keyFields: (object) => object.type,
  },
  Category: {
    fields: {
      meta: {
        merge: mergeData,
      },
      subcategories: {
        merge: mergeData,
      },
    },
    keyFields: (object) =>
      object?.subcategories ? `${object.id}:Sub` : `${object.id}:NoSub`,
  },
  FilterValueResponse: {
    keyFields: (object) =>
      object.type ? ["slug", "id", "type"] : ["slug", "id"],
  },
  ItemBrand: { keyFields: ["slug"] },
  Product: {
    fields: {
      seller: {
        details: {
          address: {
            merge: mergeData,
          },
        },
      },
    },
    keyFields: ["variationId", "id", "adsSellerId"],
  },
  Query: {
    fields: {
      recommendation: {
        merge: mergeData,
      },
    },
  },
  Recommendation: {
    keyFields: ["id", "title"],
  },
  Variation: {
    keyFields: (object) => `${object.id}:${object.type}:${object.value}`,
  },
};

export const merge = mergeData;
